import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import activityService from "./activityService";
import { setAlertError, setAlertSuccess } from "../alert/alertSlice";

const initialState = {
  activities: [],
  activity: null,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

export const getActivities = createAsyncThunk(
  "activity/getActivities",
  async (_, thunkAPI) => {
    try {
      const response = await activityService.getActivities();
      thunkAPI.dispatch(setAlertSuccess("Activities fetched successfully"));
      return response;
    } catch (error) {
      const errData = error.response?.data || null;
      const err =
        errData?.message || error.message || "Failed to fetch activities";
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(errData);
    }
  }
);

export const getPlayerActivities = createAsyncThunk(
  "activity/getPlayerActivities",
  async (playerId, thunkAPI) => {
    try {
      const response = await activityService.getPlayerActivities(playerId);
      thunkAPI.dispatch(
        setAlertSuccess("Player activities fetched successfully")
      );
      return response;
    } catch (error) {
      const errData = error.response?.data || null;
      const err =
        errData?.message ||
        error.message ||
        "Failed to fetch player activities";
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(errData);
    }
  }
);

export const logActivity = createAsyncThunk(
  "activity/logActivity",
  async (activityData, thunkAPI) => {
    try {
      const response = await activityService.logActivity(activityData);
      thunkAPI.dispatch(setAlertSuccess("Activity logged successfully"));
      return response;
    } catch (error) {
      const errData = error.response?.data || null;
      const err = errData?.message || error.message || "Failed to log activity";
      thunkAPI.dispatch(setAlertError(err));
      return thunkAPI.rejectWithValue(errData);
    }
  }
);

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
      state.activity = null;
      state.activities = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivities.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getActivities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.activities = action.payload.data;
      })
      .addCase(getActivities.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getPlayerActivities.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPlayerActivities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.activities = action.payload.data;
      })
      .addCase(getPlayerActivities.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(logActivity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(logActivity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.activity = action.payload.data;
      })
      .addCase(logActivity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = activitySlice.actions;
export default activitySlice.reducer;
